export class MouseflowHelper {
  canFlow() {
    return window._mfq ? true : false;
  }

  submitAttempt(id) {
    if (window._mfq) window._mfq.push(['formSubmitAttempt', id]);
  }

  submitSuccess(id) {
    if (window._mfq) window._mfq.push(['formSubmitSuccess', id]);
  }

  submitFailure(id) {
    if (window._mfq) window._mfq.push(['formSubmitFailure', id]);
  }
}

export default MouseflowHelper;
